import { makeAbortAll } from "./make-abort-all";
import { makeDelete } from "./make-delete";
import { makeGet } from "./make-get";
import { makeHTTPError400Handler } from "./make-http-error-400-handler";
import { makeHTTPError401Handler } from "./make-http-error-401-handler";
import { makeMainRequestErrorHandler } from "./make-main-request-error-handler";
import { makeMakeRequest } from "./make-make-request";
import { makeOngoingRequestsControllers } from "./make-ongoing-requests-controllers";
import { makePatch } from "./make-patch";
import { makePost } from "./make-post";
import { makePut } from "./make-put";
import type { Options } from "./types/Options";

export const makeHTTP = ({ options }: { options: Options }) => {
  const ongoingRequestsControllers = makeOngoingRequestsControllers();

  const makeRequest = makeMakeRequest({
    ongoingRequestsControllers,
    baseOptions: options,
  });

  const del = makeDelete({ makeRequest });
  const get = makeGet({ makeRequest });
  const patch = makePatch({ makeRequest });
  const post = makePost({ makeRequest });
  const put = makePut({ makeRequest });

  const abortAll = makeAbortAll({ ongoingRequestsControllers });

  const httpError400Handler = makeHTTPError400Handler();
  const httpError401Handler = makeHTTPError401Handler({ abortAll });

  const mainRequestErrorHandler = makeMainRequestErrorHandler({
    httpError400Handler,
    httpError401Handler,
  });

  return {
    abortAll,
    delete: del,
    get,
    httpError400Handler,
    httpError401Handler,
    mainRequestErrorHandler,
    makeRequest,
    ongoingRequestsControllers,
    patch,
    post,
    put,
  };
};
